"use strict";
/**
 * @module Util.Zlib
 *
 * @brief Utility functions for zlib compression/decompression
 */
Object.defineProperty(exports, "__esModule", { value: true });
var zlib_1 = require("zlib");
/**
 * Thin wrapper around `zlib.inflateSync`
 *
 * @param  input the compressed input
 * @return       the decompressed output
 */
function decompressSync(input) {
    return zlib_1.inflateSync(input);
}
exports.decompressSync = decompressSync;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/util/zlib-decompression.js
// module id = 2105
// module chunks = 1